import { msg } from "@lingui/core/macro";

export const startDateBeforeDateRuleMessages = {
	name: msg({ message: "Start Date before Date" }),
	description: msg({ message: "Permit Start Date must be on or before a Date" }),
	errors: {
		isAfter: msg({ message: "Permit must start on or before {date}" }),
	},
} as const;
